import script from "./CCreateCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./CCreateCategory.vue?vue&type=script&setup=true&lang=ts"

import "./CCreateCategory.vue?vue&type=style&index=0&id=4b5f3e84&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5f3e84"]])

export default __exports__